import React from 'react';

const TextAreaField = React.forwardRef(({ label, error, className = "", rows = 4, ...props }, ref) => {
  return (
    <div className={className}>
      <label className="block text-sm text-darkGray mb-1">
        {label}
      </label>
      <textarea
        ref={ref}
        rows={rows}
        className="w-full border border-secondary rounded-xl px-3 py-2 text-darkGray focus:outline-none"
        {...props}
      />
    </div>
  );
});

export default TextAreaField;